//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "IPI",
  data() {
    return {
      disabled: false,
      hasScore: false,
      text: '',
      form: {
        item1: '',
        item2: '',
        item3: '',
        item4: '',
        item5: '',
      },
      item1List: [
        { value: '0', name: '≤60' },
        { value: '1', name: '>60' },
      ],
      item2List: [
        { value: '0', name: 'Ⅰ~Ⅱ期' },
        { value: '1', name: 'Ⅲ~Ⅳ期' },
      ],
      item3List: [
        { value: '0', name: '0~1分' },
        { value: '1', name: '≥2分' },
      ],
      item4List: [
        { value: '0', name: '0~1个' },
        { value: '1', name: '≥2个' },
      ],
      item5List: [
        { value: '0', name: '正常' },
        { value: '1', name: '高于正常' },
      ],
    }
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  created() {
    this.hideLoad();
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        let result = form.item1 + form.item2 + form.item3 + form.item4 + form.item5
        if (result < 2) {
          self.text = '低危'
        } else if (result < 3) {
          self.text = '低中危'
        } else if (result < 4) {
          self.text = '高中危'
        } else if (result > 3) {
          self.text = '高危'
        }
        self.hasScore = true;
        return String(result);
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/IPI.vue